var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lald-case"},[_vm._m(0),_c('Breadcrumbs',{attrs:{"pages":[
      {
        name: 'Клинический случай',
      },
    ]}}),_c('Steps',{key:_vm.key,on:{"repeat":_vm.repeat}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h1',{staticClass:"lald-case__title"},[_vm._v("Клинический случай ДЛКЛ")])])
}]

export { render, staticRenderFns }